var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"draft"},[_c('el-tabs',[_c('el-tab-pane',{attrs:{"label":"草稿箱(32)"}},[_vm._v("\n      草稿箱列表\n    ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }